import React from 'react'
import "./Project.scss"
import { Typography } from 'antd';
import {Link} from "react-router-dom";
import { Row, Col } from 'antd';
import Bg from '../../assets/img/bg-me.png';
import LetsTalk from '../../components/LetsTalk';
import Livraison from '../../assets/img/livraison.png';
const { Title } = Typography;

function Project() {
    return (
        <div>
            <div className="bg-project"><img src={Bg} alt="bg" className="w-100" /></div>
            <div className="container" >
                <section className="first-section">
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} style={{height: 665}} align="middle">
                    <Col xs={24} sm={12} lg={8} >
                        <h5>Hey i am,</h5>
                        <h1 className="title m-0">Soufiyan benallal</h1>
                        <p> 
                        I am Junior Web developer able to build a Web presence from the ground up - from concept, navigation, layout and programming to UX and SEO. 
                        Skilled at writing well-designed, testable and efficient code using current best practices in Web development.
                         Fast learner, hard worker and team player who is proficient in an array of scripting languages and multimedia Web tools.
                        </p>
                        <LetsTalk name="Let's talk" navigate="/contact" />
                    </Col>
                    {/* <Col xs={12}>
                        <LetsTalk name="Let's talk" />
                    </Col> */}
                </Row>
                    {/* <div className="col" >
                        
                    </div>

                    <div className="col">
                        <div className="box-image">
                            <img src="https://i.picsum.photos/id/598/450/450.jpg?hmac=u4I0UIeMlDZsSNw_VcaCqUp092B7EEQ_yNxJuzO2W3U" className="w-100" alt="#" />
                        </div>
                    </div> */}
                </section>
            </div>
            <section className="container">
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} align="middle">
                    <Col xs={16}>
                        <h5>HOW I WORK</h5>
                        <h1>Developpement Process</h1>
                    </Col>
                    <Col xs={8}>
                        <div style={{width:133,float:'right'}}>
                            <LetsTalk name="Show more" />
                        </div>
                    </Col>
                </Row>
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} align="middle">
                    <Col className="gutter-row" span={8}>
                        <h2>Strategy</h2>
                        <p>
                        before starting the designing. 
                        i always make sure that i am asking the right questions and trying to accomplish the right challenges. 
                        this stage includes goals, research, analysis and solutions
                        </p>
                    </Col>
                    <Col className="gutter-row" span={8}>
                        <h2>Design </h2>
                        <p>
                        a problem solving phase. 
                        at the end. 
                        you will receive a pixel perfect design for your product. 
                        this stage includes wireframes.
                        mockups and prototypes simulating final end results before development
                        </p>
                    </Col>
                    <Col className="gutter-row" span={8}>
                        <h2>Developpement </h2>
                        <p>
                        since i'm a designer who can code too.
                        i can easily work in close collaboration with developers until the product gets a life. 
                        in case of web projects i also do front-end development
                        </p>
                    </Col>
                </Row>
            </section>
        
            <section className="container">
                
                
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                    <Col>
                    <h5>HOW I WORK</h5>
                    <h1>Experciences Delivered</h1>
                    </Col>
                </Row>
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} align="middle" >
                    <Col className="gutter-row" span={12}>
                        <img src={Livraison} className="w-100" alt="#" />
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <div>
                            <h2>Delivrey Company</h2>
                            <p>
                                
                            </p>
                            <LetsTalk name="Show project" />
                        </div>
                    </Col>
                </Row>
                
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} align="middle" >
                    <Col className="gutter-row" span={12}>
                        <div >
                            <img src="https://i.picsum.photos/id/598/450/450.jpg?hmac=u4I0UIeMlDZsSNw_VcaCqUp092B7EEQ_yNxJuzO2W3U" className="w-100" alt="#" />
                        </div>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <div>
                            <h2>Title 1</h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                Aenean massa. 
                            </p>
                            <LetsTalk name="Let's talk" />
                        </div>
                    </Col>
                </Row>
                
                <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]} align="middle" >
                    <Col className="gutter-row" span={12}>
                        <img src="https://i.picsum.photos/id/598/450/450.jpg?hmac=u4I0UIeMlDZsSNw_VcaCqUp092B7EEQ_yNxJuzO2W3U" className="w-100" alt="#" />
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <div>
                            <h2>Title 1</h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                Aenean massa. 
                            </p>
                            <LetsTalk name="Let's talk" />
                        </div>
                    </Col>
                </Row>
                
            </section>
            
            <section className="container">
                <Row>
                    <Col className="gutter-row" span={12}>
                        <h5>NICE TO MEET YOU</h5>
                        <h1>Hi there, I'm Soufiyan</h1>
                        <p>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Aenean massa. 
                            Cum sociis natoque penatibus et magnis dis
                        </p>
                        <p>
                            Aenean massa. 
                            Cum sociis natoque penatibus et magnis dis
                        </p>
                        <p>
                            Lorem ipsum dolor sit adipiscing elit. 
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                            Aenean massa. 
                            Cum sociis natoque penatibus et magnis dis
                        </p>
                        <p>
                            Aenean massa. 
                            Cum sociis natoque penatibus et magnis dis
                        </p>
                        <p>
                            Lorem ipsum dolor sit adipiscing elit. 
                        </p>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Row  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 },{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                            <Col span={12} offset={6}>
                            <ion-icon size="large" name="logo-facebook"></ion-icon>
                            <ion-icon size="large" name="logo-twitter"></ion-icon>
                            <ion-icon size="large" name="logo-google"></ion-icon>
                            <ion-icon size="large" name="logo-whatsapp"></ion-icon>
                            <ion-icon size="large" name="logo-instagram"></ion-icon>
                            <ion-icon size="large" name="logo-linkedin"></ion-icon>
                            <ion-icon size="large" name="logo-github"></ion-icon>
                                <h5>h5. Ant Design</h5>
                                <h1>h1. Ant Design</h1>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Aenean massa. 
                                    Cum sociis natoque penatibus et magnis dis
                                </p>
                                <p>
                                    Aenean massa. 
                                    Cum sociis natoque penatibus et magnis dis
                                </p>
                                <p>
                                    Lorem ipsum dolor sit adipiscing elit. 
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. 
                                    Aenean massa. 
                                    Cum sociis natoque penatibus et magnis dis
                                </p>
                                <p>
                                    Aenean massa. 
                                    Cum sociis natoque penatibus et magnis dis
                                </p>
                                <p>
                                    Lorem ipsum dolor sit adipiscing elit. 
                                </p>
                            </Col>
                        </Row>
                    </Col>
                    
                </Row>
            </section>
        
        </div>
    )
}

export default Project
